import Vue from 'vue'

import uiEventCalendar from './src/ui-event-calendar.vue';

Vue.component(uiEventCalendar.extendOptions.name, uiEventCalendar);

export default uiEventCalendar;



//////////////////
// WEBPACK FOOTER
// ./~/ui-event-calendar/index.js
// module id = 548
// module chunks = 0